import React, { lazy, Suspense, useContext } from 'react'

import { EndUser } from '@driftt/api-types'

import Portal from 'components/Portal'
import { CurrentUserContext } from 'context/currentUserContext'
import { ActivityEndUser } from 'modules/accountActivity/domain'

const EnrollModalComponent = lazy(() => import('@driftt/enroll-modal'))

export const EnrollModal: React.FC<{
  onClose: () => void
  endUserData: ActivityEndUser | EndUser
  useOutreach: boolean
}> = ({ onClose, endUserData, useOutreach }) => {
  const currentUser = useContext(CurrentUserContext)

  if (!endUserData || !endUserData?.email) {
    return <></>
  }

  return (
    <Portal>
      <Suspense fallback={null}>
        <EnrollModalComponent
          open={true}
          endUserDisplayName={endUserData?.name ?? endUserData?.email}
          endUserEmail={endUserData?.email}
          userEmail={currentUser?.email || ''}
          onClose={onClose}
          useOutreach={useOutreach}
        />
      </Suspense>
    </Portal>
  )
}
